import { numberToPrettyString } from '@cian/utils';

export function formatArea(area?: number): string {
  if (area === undefined || area === null) {
    return '';
  }

  return `${numberToPrettyString(Math.round(area * 10) / 10)} м²`;
}
